import { useStore, selectLocale } from '@/infra/store';
import { ptBR } from './pt-BR';
import { en } from './en';
import type { Locale, TranslationKey, Dict } from './types';

export type { Locale, TranslationKey, Dict };

const dicts: Record<Locale, Dict> = { 'pt-BR': ptBR, en };

function format(template: string, params?: Record<string, string>): string {
  if (!params) return template;
  let s = template;
  for (const [k, v] of Object.entries(params)) {
    s = s.split(`{${k}}`).join(v);
  }
  return s;
}

/** t() não-reativo (para Phaser/services). Lê o locale atual da store. */
export function t(key: TranslationKey, params?: Record<string, string>): string {
  const locale = useStore.getState().settings.locale;
  const dict = dicts[locale];
  return format(dict[key] ?? key, params);
}

/** Hook reativo para componentes React. */
export function useT(): (key: TranslationKey, params?: Record<string, string>) => string {
  const locale = useStore(selectLocale);
  const dict = dicts[locale];
  return (key, params) => format(dict[key] ?? key, params);
}

export function detectLocaleFromBrowser(): Locale {
  if (typeof navigator === 'undefined') return 'pt-BR';
  const lang = (navigator.language ?? '').toLowerCase();
  if (lang.startsWith('en')) return 'en';
  return 'pt-BR';
}
